import { type HttpClientConfig } from 'core/infra/http/HttpClient'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

type GetInspectionCertificatesFactoryDependencies = {
  repository: ShipmentRepository
}

type Params = {
  shipmentUUID: string
  stopIndex: number
  config: Partial<HttpClientConfig>
  params: {
    loadTypeId: string
    appointmentDate: string
    facilityTimezone?: string
  }
}

export function getOpenDockWarehouseAvailabilityFactory({
  repository,
}: GetInspectionCertificatesFactoryDependencies) {
  return async function getOpenDockWarehouseAvailability({
    shipmentUUID,
    stopIndex,
    params,
    config,
  }: Params) {
    try {
      return await repository.getOpenDockWarehouseAvailability(
        shipmentUUID,
        stopIndex,
        params,
        config
      )
    } catch (error) {
      throw new Error('Could not get OpenDock warehouse availability', { cause: error as Error })
    }
  }
}

export function getOpenDockWarehouseAvailability({
  shipmentUUID,
  stopIndex,
  config,
  params,
}: Params) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const newGetOpenDockWarehouseAvailability = getOpenDockWarehouseAvailabilityFactory({
    repository,
  })
  return newGetOpenDockWarehouseAvailability({
    shipmentUUID,
    stopIndex,
    params,
    config,
  })
}
